import * as React from "react";
import Wait from "../../wait";
import ReadService from "../../../service/read";
import PopDetail from "../../popdetail";
import CreateService from "../../../service/create";

export default class ParcelRemark extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            stage:1,
            data:[],
            action:'approve',
            stages:['Mobile Data','Rejected','GIS Approval','ALO Approval','Paid','Printed','','',''],
        }
        this.submitReject = this.submitReject.bind(this)
        this.loadData = this.loadData.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange= e =>{
        this.setState({[e.target.name]: e.target.value});

        if (e.target.name==='action' && e.target.value==='reject'){
            document.getElementById('txt_reject').value=''
        }
    }

    componentDidMount() {
        if (this.props.is_open===true){
            //ParcelRemark.popRemark()
        }
        this.loadData()
    }

    loadData(){
        try {
            Wait.show("Fetching Remarks....")
            ReadService.fetchRemark(this.props.parcel.id).then(r=>{
                Wait.dismiss()
                try {
                    console.log(r.data.results)
                    this.setState({
                        data:r.data.results
                    })
                }catch (e) {
                    console.log(e)
                }
            })
        }catch (e) {
            console.log(e)
        }
    }
    
    static popRemark(){
        document.getElementById('pop_remark').style.display='inherit'
    }
    
    static closeRemarkPop(){
        document.getElementById('pop_remark').style.display='none'
        document.getElementById('txt_reject').value = ''
    }

    noHandler(){PopDetail.dismiss()}
    handleMessage(){ParcelRemark.popRemark()}

    submitReject(){
        let txt = document.getElementById('txt_reject').value.trim()
        let action = this.state.action
        if (txt.length>3){

            try {
                CreateService.createParcelRemark({
                    parcelId:this.props.parcel.id,
                    action: action,
                    description:txt,
                    screen_code:this.props.screen_code,
                    task_id:this.props.taskId
                }).then(r=>{
                    ParcelRemark.closeRemarkPop()
                        this.loadData()
                })
            }catch (e) {
                console.log(e)
            }
        }else{
            alert('Too Short Message')
        }
    }

    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        const container = {
            width: '100%',
            height: '60vh',
            overflow: 'hidden',
            fontFamily,
            background: '#f6f8fa'
        };
        
        const header = {
            background: 'transparent',
            color: '#395d9a',
            padding: '8px 24px',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '12px'
        };
        
        const buttonGroup = {
            display: 'flex',
            gap: '8px',
            flexWrap: 'wrap'
        };
        
        const button = {
            padding: '10px 16px',
            border: 'none',
            borderRadius: 0,
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontFamily,
            minWidth: '100px',
            justifyContent: 'center'
        };
        
        const refreshBtn = {
            ...button,
            background: '#f8f9fa',
            color: '#395d9a',
            border: '1px solid #e0e7ef'
        };
        
        const addBtn = {
            ...button,
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            boxShadow: '0 2px 8px rgba(57,93,154,0.15)'
        };
        
        const content = {
            padding: '16px',
            height: 'calc(60vh - 60px)',
            overflow: 'auto'
        };
        
        const tableContainer = {
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(57,93,154,0.08)',
            overflow: 'hidden',
            border: '1px solid #e0e7ef'
        };
        
        const table = {
            width: '100%',
            borderCollapse: 'collapse',
            fontFamily
        };
        
        const th = {
            background: '#f8f9fa',
            color: '#395d9a',
            fontWeight: '700',
            fontSize: '14px',
            padding: '16px 12px',
            textAlign: 'left',
            borderBottom: '2px solid #e0e7ef',
            position: 'sticky',
            top: 0,
            zIndex: 2
        };
        
        const td = {
            padding: '14px 12px',
            borderBottom: '1px solid #f0f0f0',
            fontSize: '14px',
            color: '#333'
        };
        
        const actionBadge = (action) => ({
            padding: '4px 12px',
            borderRadius: '20px',
            fontSize: '12px',
            fontWeight: '600',
            textTransform: 'uppercase',
            background: action === 'approve' ? '#d4edda' : '#f8d7da',
            color: action === 'approve' ? '#155724' : '#721c24'
        });
        
        const modal = {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            zIndex: 1005,
            width: '90%',
            maxWidth: '500px',
            maxHeight: '90vh',
            overflow: 'auto'
        };
        
        const modalHeader = {
            padding: '20px 24px 16px 24px',
            borderBottom: '1px solid #e0e7ef',
            background: '#f8f9fa'
        };
        
        const modalTitle = {
            fontSize: '18px',
            fontWeight: '700',
            color: '#395d9a',
            margin: 0,
            fontFamily
        };
        
        const modalBody = {
            padding: '24px'
        };
        
        const formGroup = {
            marginBottom: '20px'
        };
        
        const label = {
            display: 'block',
            marginBottom: '8px',
            fontWeight: '600',
            color: '#333',
            fontSize: '14px',
            fontFamily
        };
        
        const radioGroup = {
            display: 'flex',
            gap: '20px',
            marginBottom: '8px'
        };
        
        const radioItem = {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer'
        };
        
        const textarea = {
            width: '100%',
            padding: '12px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: fontFamily,
            resize: 'vertical',
            minHeight: '100px',
            boxSizing: 'border-box'
        };
        
        const modalFooter = {
            padding: '16px 24px 24px 24px',
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end',
            borderTop: '1px solid #e0e7ef',
            background: '#f8f9fa'
        };
        
        const submitBtn = {
            ...button,
            background: '#27ae60',
            color: 'white'
        };
        
        const cancelBtn = {
            ...button,
            background: '#6c757d',
            color: 'white'
        };
        
        const responsive = `
            @media (max-width: 768px) {
                .remark-header { flex-direction: column; align-items: stretch; }
                .remark-search { min-width: 100%; }
                .remark-buttons { justify-content: center; }
                .remark-table { font-size: 12px; }
                .remark-th, .remark-td { padding: 8px 6px; }
                .remark-modal { width: 95%; margin: 20px; }
            }
            @media (max-width: 480px) {
                .remark-content { padding: 16px; }
                .remark-table { font-size: 11px; }
                .remark-th, .remark-td { padding: 6px 4px; }
            }
        `;

        return (
            <div style={container}>
                <style>{responsive}</style>
                
                {/* Header */}
                <div className="remark-header" style={header}>
                    <div className="remark-buttons" style={buttonGroup}>
                        <button 
                            style={refreshBtn}
                            onClick={() => this.loadData(0)}
                            onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
                            onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                        >
                            <span className="fa fa-refresh"/> Refresh
                    </button>
                        {sessionStorage.getItem('user_groups') === 'ALO' && (
                            <button 
                                style={addBtn}
                                onClick={() => ParcelRemark.popRemark()}
                                onMouseOver={e => e.currentTarget.style.background = '#229954'}
                                onMouseOut={e => e.currentTarget.style.background = '#27ae60'}
                            >
                                <span className="fa fa-plus"/> Add New
                            </button>
                        )}
                </div>
            </div>

                {/* Content */}
                <div className="remark-content" style={content}>
                    <div style={tableContainer}>
                        <table className="remark-table" style={table}>
                   <thead>
                       <tr>
                                    <th className="remark-th" style={th}>#</th>
                                    <th className="remark-th" style={th}>Created At</th>
                                    <th className="remark-th" style={th}>Action</th>
                                    <th className="remark-th" style={th}>Remark</th>
                                    <th className="remark-th" style={th}>Created By</th>
                       </tr>
                   </thead>
                   <tbody>
                                {this.state.data.map((d, i) => (
                                    <tr key={i} style={{background: i % 2 === 0 ? '#f8f9fa' : 'white'}}>
                                        <td className="remark-td" style={td}>{i + 1}</td>
                                        <td className="remark-td" style={td}>{d.datetime}</td>
                                        <td className="remark-td" style={td}>
                                            <span style={actionBadge(d.action)}>{d.action}</span>
                                        </td>
                                        <td className="remark-td" style={td}>{d.description}</td>
                                        <td className="remark-td" style={td}>{d.created_by}</td>
                                    </tr>
                                ))}
                                {this.state.data.length === 0 && (
                                    <tr>
                                        <td colSpan="5" style={{...td, textAlign: 'center', color: '#666', padding: '40px'}}>
                                            No remarks found
                                        </td>
                                    </tr>
                                )}
                   </tbody>
               </table>
           </div>
                </div>

                {/* Modal */}
                <div 
                    id="pop_remark"
                    className="remark-modal"
                    style={{
                        ...modal,
                        display: 'none'
                    }}
                >
                    <div style={modalHeader}>
                        <h3 style={modalTitle}>
                            <span className="fa fa-comment" style={{marginRight: '8px'}}/>
                            Add New Remark
                        </h3>
                    </div>
                    
                    <div style={modalBody}>
                        <div style={formGroup}>
                            <label style={label}>Action</label>
                            <div style={radioGroup}>
                                <label style={radioItem}>
                                    <input 
                                        type="radio" 
                                        name="action" 
                                        value="approve" 
                                        onChange={this.handleChange} 
                                        defaultChecked={true}
                                    />
                                    <span style={{color: '#27ae60', fontWeight: '600'}}>Approve</span>
                                </label>
                                <label style={radioItem}>
                                    <input 
                                        type="radio" 
                                        name="action" 
                                        value="reject" 
                                        onChange={this.handleChange}
                                    />
                                    <span style={{color: '#e74c3c', fontWeight: '600'}}>Reject</span>
                                </label>
                            </div>
                        </div>
                        
                        <div style={formGroup}>
                            <label style={label}>Message</label>
                            <textarea 
                                name="message" 
                                onChange={this.handleChange} 
                                defaultValue="Approved" 
                                id="txt_reject" 
                                placeholder="Type your remark here..." 
                                style={textarea}
                            />
                        </div>
                    </div>
                    
                    <div style={modalFooter}>
                        <button 
                            style={cancelBtn}
                            onClick={() => ParcelRemark.closeRemarkPop()}
                            onMouseOver={e => e.currentTarget.style.background = '#5a6268'}
                            onMouseOut={e => e.currentTarget.style.background = '#6c757d'}
                        >
                            Cancel
                        </button>
                        <button 
                            style={submitBtn}
                            onClick={() => this.submitReject()}
                            onMouseOver={e => e.currentTarget.style.background = '#229954'}
                            onMouseOut={e => e.currentTarget.style.background = '#27ae60'}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        );
    }
} 